/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const RelatedItemsLink = (i18n: any) => ({
   replace: true,
   templateUrl: '/assets/relatedItemsToggle.html',
   controller: 'RelatedItemsCtrl',

   link(scope: any) {
      return scope.i18n || (scope.i18n = i18n)
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'i18n' implicitly has an 'any' type.
const RelatedItems = (i18n, utils, types) => ({
   replace: true,
   templateUrl: '/assets/relatedItems.html',
   controller: 'RelatedItemsCtrl',

   link(scope: any, elm: any, attrs: any) {
      if (!scope.i18n) { scope.i18n = i18n }
      if (!scope.types) { scope.types = types }
      return scope.titleCase || (scope.titleCase = utils.titleCase)
   }
})

angular.module('summonApp.directives')
   .directive('relatedItemsLink', ['translationService', RelatedItemsLink])
   .directive('relatedItems', ['translationService', 'utilitiesService', '$relatedItemTypes', RelatedItems])
